/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { V1AuthServiceCallbackPost200Response } from '../model';
// @ts-ignore
import { V1AuthServiceCallbackPostRequest } from '../model';
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle authentication callback from external services (e.g. upsider-card). Performs housekeeping operations to manage organization and user data by  creating, modifying, and updating organizations and users in the credit database. 
         * @summary External Service Authentication Callback
         * @param {'upsider-card'} service External service name
         * @param {V1AuthServiceCallbackPostRequest} v1AuthServiceCallbackPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AuthServiceCallbackPost: async (service: 'upsider-card', v1AuthServiceCallbackPostRequest: V1AuthServiceCallbackPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'service' is not null or undefined
            assertParamExists('v1AuthServiceCallbackPost', 'service', service)
            // verify required parameter 'v1AuthServiceCallbackPostRequest' is not null or undefined
            assertParamExists('v1AuthServiceCallbackPost', 'v1AuthServiceCallbackPostRequest', v1AuthServiceCallbackPostRequest)
            const localVarPath = `/v1/auth/{service}/callback`
                .replace(`{${"service"}}`, encodeURIComponent(String(service)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1AuthServiceCallbackPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle authentication callback from external services (e.g. upsider-card). Performs housekeeping operations to manage organization and user data by  creating, modifying, and updating organizations and users in the credit database. 
         * @summary External Service Authentication Callback
         * @param {'upsider-card'} service External service name
         * @param {V1AuthServiceCallbackPostRequest} v1AuthServiceCallbackPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AuthServiceCallbackPost(service: 'upsider-card', v1AuthServiceCallbackPostRequest: V1AuthServiceCallbackPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AuthServiceCallbackPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AuthServiceCallbackPost(service, v1AuthServiceCallbackPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Handle authentication callback from external services (e.g. upsider-card). Performs housekeeping operations to manage organization and user data by  creating, modifying, and updating organizations and users in the credit database. 
         * @summary External Service Authentication Callback
         * @param {AuthenticationApiV1AuthServiceCallbackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AuthServiceCallbackPost(requestParameters: AuthenticationApiV1AuthServiceCallbackPostRequest, options?: AxiosRequestConfig): AxiosPromise<V1AuthServiceCallbackPost200Response> {
            return localVarFp.v1AuthServiceCallbackPost(requestParameters.service, requestParameters.v1AuthServiceCallbackPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v1AuthServiceCallbackPost operation in AuthenticationApi.
 * @export
 * @interface AuthenticationApiV1AuthServiceCallbackPostRequest
 */
export interface AuthenticationApiV1AuthServiceCallbackPostRequest {
    /**
     * External service name
     * @type {'upsider-card'}
     * @memberof AuthenticationApiV1AuthServiceCallbackPost
     */
    readonly service: 'upsider-card'

    /**
     * 
     * @type {V1AuthServiceCallbackPostRequest}
     * @memberof AuthenticationApiV1AuthServiceCallbackPost
     */
    readonly v1AuthServiceCallbackPostRequest: V1AuthServiceCallbackPostRequest
}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Handle authentication callback from external services (e.g. upsider-card). Performs housekeeping operations to manage organization and user data by  creating, modifying, and updating organizations and users in the credit database. 
     * @summary External Service Authentication Callback
     * @param {AuthenticationApiV1AuthServiceCallbackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public v1AuthServiceCallbackPost(requestParameters: AuthenticationApiV1AuthServiceCallbackPostRequest, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).v1AuthServiceCallbackPost(requestParameters.service, requestParameters.v1AuthServiceCallbackPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
